var getBEMClasses = function (blockName) { return [
    blockName,
    function (modifierName) { return "".concat(blockName, "--").concat(modifierName); },
    function (elementName) { return getBEMClasses("".concat(blockName, "__").concat(elementName)); }
]; };

export { getBEMClasses };
